import React, { useEffect, useState, useRef } from 'react'


const About_Event = ({ event }) => {


    return <div>
        <p className="p-2 mt-2 rounded mb-2 eventCardfont" style={{ fontSize: '15px', fontWeight: '500' }}> <span dangerouslySetInnerHTML={{ __html: event.About_Tour }}></span></p>
    </div>
}

const Itinerary_Event = ({ event }) => {
    return (
        <>
            {event.day_itinerary.map((day, dayIndex) => (


                <div key={dayIndex} className='eventCardfont p-2 rounded mb-2' style={{ fontSize: '15px', fontWeight: '500' }}>
                    <p className="mb-1"><b>Day </b>:  <span dangerouslySetInnerHTML={{ __html: day.daysnumber }}></span>
                        <span>{day.name ? ` | ${day.name}` : ''}</span>
                    </p>
                    {day.tags && (
                        <p className="mb-1"><b>Highlight : </b><br /><span dangerouslySetInnerHTML={{ __html: day.tags }}></span></p>
                    )}
                    {day.details && (
                        <p className="mb-1 details_tab"><b>Details :</b><br /><span dangerouslySetInnerHTML={{ __html: day.details }}></span></p>
                    )}
                </div>
            ))}
        </>
    )
}

const Inclusions_Event = ({ event }) => {


    return (
        <>
            <div>
                <p className="p-2 mt-2 rounded mb-2 eventCardfont" style={{ fontSize: '15px', fontWeight: '500' }}><b><i className="fa-regular fa-circle-check" style={{ color: "#34b233" }}></i><span className="px-2">Inclusion</span></b> <br /><span dangerouslySetInnerHTML={{ __html: event.inclusions }}></span></p>
            </div>
            <div>
                <p className="p-2 mt-2 rounded mb-2 eventCardfont" style={{ fontSize: '15px', fontWeight: '500' }}><b><i className="fa-regular fa-circle-xmark" style={{ color: "rgb(178 51 89)" }}></i><span className="px-2">Exclusion</span></b> <br /><span dangerouslySetInnerHTML={{ __html: event.exclusions }}></span></p>
            </div>
        </>
    )
}


const Pricing = ({ event }) => {

    const firstBatch = event.batches[0]
    console.log("firstBatch", firstBatch)
    const date = new Date(firstBatch?.startdate)
    const dates = event.batches.length

    const obj1 = date instanceof Date && !isNaN(date) ? {
        date: date.getDate(),
        month: date.toLocaleString('default', { month: 'short' }),
        day: date.toLocaleString('default', { weekday: 'short' }),
        year: date.getFullYear(),
    } : null
    console.log(date, obj1)
    return (
        <>
            <div className='pb-5'>
                {obj1 && <div>
                    <p style={{ fontWeight: '400' }} className="rounded mb-0 eventCardfont">Next upcoming on</p>
                    <p className="mb-0"><b style={{ fontWeight: '600', fontSize: '15px' }}>{obj1.day} - {obj1.month}. {obj1.date}, {obj1.year}</b></p>
                </div>}
                <div className='mt-2'>
                    <span style={{ fontSize: '16px', fontWeight: '600' }}>Ticket prices</span>
                    {firstBatch?.eventbatchprice?.length > 0 ? firstBatch?.eventbatchprice?.map((price, index) => (
                        <div className='d-flex justify-content-between align-items-center w-100 mt-2'>
                            <div className='d-flex align-items-center justify-content-center' style={{ gap: '5px' }}>
                                <img width="30" height="30" src={`${process.env.PUBLIC_URL}/ticket.png`} alt="ticket" />
                                <span style={{ fontWeight: '400' }}>{price.attribute}</span>
                            </div>
                            <div>
                                <span style={{ fontWeight: '600' }}>&#8377;{Math.round(price.price)}</span>
                            </div>
                        </div>
                    ))
                        :
                        event.eventprice.map((price, index) => (
                            <div className='d-flex justify-content-between align-items-center w-100 mt-2'>
                                <div className='d-flex align-items-center justify-content-center' style={{ gap: '8px', maxWidth: '70%' }}>
                                    <img width="30" height="30" src={`${process.env.PUBLIC_URL}/ticket.png`} alt="ticket" />
                                    <span style={{ fontWeight: '400' }}>{price.attribute}</span>
                                </div>
                                <div>
                                    <span style={{ fontWeight: '600' }}>&#8377;{Math.round(price.price)}</span>
                                </div>
                            </div>
                        ))}
                    {
                        firstBatch?.eventbatchprice?.length == 0 && event?.eventprice?.length == 0 && <div>
                            <span style={{}}>Starting from <span style={{ fontWeight: '600', fontSize: '18px' }}>&#8377;{event?.price}</span></span>
                        </div>
                    }
                </div>
                {/* {dates>1 && <a href="javascript:void(0);" type="button" className="mt-2" data-bs-toggle="modal" data-bs-target="#datesModal">  See all dates and pricing</a>} */}
                {dates > 1 && <button data-bs-toggle="modal" data-bs-target="#datesModal" type="button" className='mt-4 d-block alldates m-auto' >All Dates & Prices</button>}
                <span className='terms mt-1 m-auto d-block text-center'>*Prices may vary depending on dates</span>
            </div>
        </>
    )
}

const NavigationTab = ({ event }) => {
    console.log("event", event)
    const [tabs, setTabs] = useState([]);
    const [activeTab, setActiveTab] = useState('');
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)
    const [touchVertStart, setTouchVertStart] = useState(0)
    const [touchVertEnd, setTouchVertEnd] = useState(0)

    // the required distance between touchStart and touchEnd to be detected as a swipe
    const minSwipeDistance = 30

    const tabIndicatorRef = useRef(null);






    const onTouchStart = (e) => {
        setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX)
        setTouchVertEnd(0)
        setTouchVertStart(e.targetTouches[0].clientY)
    }

    const onTouchMove = (e) => { setTouchEnd(e.targetTouches[0].clientX); setTouchVertEnd(e.targetTouches[0].clientY) }

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return
        if (!touchVertStart || !touchVertEnd) return
        const distance = touchStart - touchEnd
        const distanceVert = touchVertStart - touchVertEnd
        const isUpSwipe = distanceVert > minSwipeDistance
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (Math.abs(touchStart - touchEnd) > Math.abs(touchVertStart - touchVertEnd)) {
            setActiveTab(tabs[tabs.indexOf(activeTab) + (isLeftSwipe ? 1 : -1)] || activeTab)
        }
        // add your conditional logic here
    }

    useEffect(() => {
        let presentTabs = [];
        if (event.About_Tour) {
            presentTabs.push('About');
        }
        if (event.day_itinerary.length > 0) {
            presentTabs.push('Itinerary');
        }
        presentTabs.push('Pricing')
        if (event.inclusions) {
            presentTabs.push('Inclusions');
        }
        setTabs(presentTabs);
        setActiveTab(presentTabs[0]);
    }, [])
    return (
        <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
            <div>
                <ul className='tabs_list'>
                    {tabs.map((tab, index) => (

                        <li style={{ cursor: 'pointer', fontWeight: '600' }} key={tab} className={` ${activeTab == tab ? `activetab` : ''}`} onClick={() => { console.log(tab); setActiveTab(tab) }}>{tab}</li>


                    ))}
                    {/* <div className='tab_indicator' style={{ left: `${tabs.indexOf(activeTab) * 25}%` }}></div> */}
                    {/* <span className='tab_indicator'></span> */}
                </ul>
            </div>
            <div className='pb-4'>
                {activeTab === 'About' && <About_Event event={event} />}
                {activeTab === 'Itinerary' && <Itinerary_Event event={event} />}
                {activeTab === 'Inclusions' && <Inclusions_Event event={event} />}
                {activeTab === 'Pricing' && <Pricing event={event} />}
            </div>
        </div>
    )
}

export default NavigationTab
